'user strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.statistics_show', {
    url: 'statistics/:id',
    template: '<statistics-show></statistics-show>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/show/statistics_show.routes.js